import React from 'react';
import {
  makeStyles, Box, Typography,
} from '@material-ui/core';
import UserInfoSubInfo from 'common/components/UserInfoSubInfo';
// import Communication from 'common/components/Communication';
import { getHostPublicProfileSlug } from 'views/profiles/utils/publicProfileSlugHelper';
import { withTranslation } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: '500',
    marginBottom: theme.spacing(1.5),
  },
  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: theme.spacing(1.5),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  // communication: {
  //   [theme.breakpoints.down('sm')]: {
  //     marginTop: theme.spacing(1.5),
  //   },
  // },
}));

const HostedBy = (props) => {
  const classes = useStyles();
  const {
    t,
    image,
    name,
    id,
    rate,
    trips,
    date,
    commercialHostToolTip,
    translatePath = true,
    ownerUserId
  } = props;
  return (
    <>
      <Box>
        <Typography variant="h3" className={classes.bold}>
          {t('fe_es_hosted_by_component:hosted_by')}
        </Typography>

        <Box className={classes.inner}>
          <UserInfoSubInfo
            image={image}
            name={name}
            rate={rate}
            trips={trips}
            joinedOnDate={date}
            verified={false}
            commercialHostToolTip={commercialHostToolTip}
            ownerUserId={ownerUserId}
            moreInfoPath={`/motorcycle-rentals/${getHostPublicProfileSlug(name, id)}`}
            translatePath={translatePath}
            showMessageBtn
          />
          {/* This has no data */}
          {/* {(callFun || msgFun) && (
            <Box className={classes.communication}>
              <Communication callFun={callFun} msgFun={msgFun} moreInfoPath={moreInfoPath} />
            </Box>
          )} */}
        </Box>
      </Box>
    </>
  );
};

export default withTranslation('fe_es_hosted_by_component')(HostedBy);
